import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Input — repaginação 2026-05-08.
 *
 * Padrão "Calcula MEI Vivo":
 * - Radius 12px (rounded-xl)
 * - Altura maior (h-12) pra touch
 * - Focus glow verde sutil em vez de só border
 * - Transição suave na borda + sombra
 */
function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        // Base
        "h-12 w-full min-w-0",
        "bg-card border border-border rounded-xl",
        "px-4 py-2",
        "text-[15px] leading-tight",
        "placeholder:text-[rgb(var(--ink-soft))]",
        "selection:bg-[rgb(var(--green)/0.18)] selection:text-foreground",
        // Transitions
        "transition-[border-color,background-color,box-shadow] duration-200 ease-out",
        "outline-none",
        // Focus — borda verde + glow sutil
        "focus:border-[rgb(var(--green))] focus:shadow-[0_0_0_4px_rgb(16_185_129_/_0.12)]",
        // Disabled
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        // File inputs
        "file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
        // Aria invalid
        "aria-invalid:border-destructive aria-invalid:bg-destructive/5",
        className
      )}
      {...props}
    />
  )
}

export { Input }
